exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-tag {\n  color: #fff !important;\n  background-color: #20a8d8 !important;\n  border-color: #20a8d8 !important;\n}\n.input-tag .remove{\n  color: #fff !important;\n}\n.vue-input-tag-wrapper{\n  display: block !important;\n  width: 100% !important;\n  font-size: 0.875rem !important;\n  padding: 0.5rem 1rem !important;\n  line-height: 1.25 !important;\n  color: #607d8b !important;\n  background-color: #fff !important;\n  background-image: none !important;\n  background-clip: padding-box !important;\n  border: 1px solid rgba(0, 0, 0, 0.15) !important;\n  border-radius: 0 !important;\n  -webkit-appearance: none !important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1de823d6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/rocket/configurations/Form.vue
// module id = 853
// module chunks = 1